// Coreografía de la landing: entrada orquestada del hero al cargar,
// reveals silenciosos al scroll y count-up de los stats del trust strip.
import { animate, inView, stagger } from 'motion';

const EASE_OUT = [0.16, 1, 0.3, 1];

function hide(elements) {
    elements.forEach((el) => {
        el.style.opacity = '0';
    });
}

function riseIn(elements, options) {
    return animate(elements, { opacity: [0, 1], y: [16, 0] }, {
        duration: 0.7,
        ease: EASE_OUT,
        ...options,
    });
}

// Revela `elements` (en cascada) la primera vez que `trigger` entra al viewport.
function revealOnScroll(trigger, elements, options) {
    if (!trigger || !elements.length) return;
    hide(elements);
    let done = false;
    inView(trigger, () => {
        if (done) return;
        done = true;
        riseIn(elements, options);
    }, { amount: 0.2 });
}

function heroSequence() {
    const items = Array.from(document.querySelectorAll(
        '.hero-eyebrow, .hero-title, .hero-subtitle, .login-section'
    ));
    if (!items.length) return;
    hide(items);
    riseIn(items, { duration: 0.8, delay: stagger(0.09, { startDelay: 0.05 }) });
}

// Firma de la landing: los números del trust strip cuentan desde cero.
function trustCountUp() {
    const strip = document.querySelector('.trust-strip');
    if (!strip) return;
    const numbers = Array.from(strip.querySelectorAll('.trust-number'));
    const labels = Array.from(strip.querySelectorAll('.trust-label'));
    hide(numbers.concat(labels));
    let done = false;
    inView(strip, () => {
        if (done) return;
        done = true;
        riseIn(numbers.concat(labels), { duration: 0.6, delay: stagger(0.05) });
        numbers.forEach((el) => {
            const node = el.firstChild;
            const target = parseInt(node.textContent, 10);
            if (!Number.isFinite(target)) return;
            animate(0, target, {
                duration: 1.2,
                ease: 'circOut',
                onUpdate: (v) => {
                    node.textContent = String(Math.round(v));
                },
            });
        });
    }, { amount: 0.4 });
}

function mockupSequence() {
    const mockup = document.querySelector('.showcase-mockup');
    if (!mockup) return;
    const kpis = Array.from(mockup.querySelectorAll('.mockup-kpi'));
    const bars = Array.from(mockup.querySelectorAll('.mockup-bar'));
    const fills = Array.from(mockup.querySelectorAll('.mockup-list-bar > span'));
    const badge = mockup.querySelector('.mockup-badge');

    hide(kpis);
    bars.forEach((el) => {
        el.style.transform = 'scaleY(0)';
    });
    fills.forEach((el) => {
        el.style.transform = 'scaleX(0)';
    });
    if (badge) {
        badge.style.opacity = '0';
    }

    let done = false;
    inView(mockup, () => {
        if (done) return;
        done = true;
        riseIn(kpis, { duration: 0.5, delay: stagger(0.06) });
        animate(bars, { scaleY: [0, 1] }, {
            duration: 0.7,
            ease: EASE_OUT,
            delay: stagger(0.04, { startDelay: 0.2 }),
        });
        animate(fills, { scaleX: [0, 1] }, {
            duration: 0.8,
            ease: EASE_OUT,
            delay: stagger(0.08, { startDelay: 0.45 }),
        });
        if (badge) {
            animate(badge, { opacity: [0, 1], scale: [0.92, 1] }, {
                duration: 0.5,
                ease: EASE_OUT,
                delay: 0.7,
            });
        }
    }, { amount: 0.3 });
}

function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    heroSequence();
    trustCountUp();
    mockupSequence();

    document.querySelectorAll('.section-header').forEach((header) => {
        revealOnScroll(header, Array.from(header.children), { delay: stagger(0.08) });
    });

    const featuresGrid = document.querySelector('.features-grid');
    if (featuresGrid) {
        revealOnScroll(featuresGrid, Array.from(featuresGrid.querySelectorAll('.feature-card')), {
            delay: stagger(0.07),
        });
    }

    const showcaseCopy = document.querySelector('.showcase-copy');
    if (showcaseCopy) {
        revealOnScroll(showcaseCopy, Array.from(showcaseCopy.children), { delay: stagger(0.08) });
    }

    const processSteps = document.querySelector('.process-steps');
    if (processSteps) {
        revealOnScroll(processSteps, Array.from(processSteps.querySelectorAll('.process-step')), {
            delay: stagger(0.09),
        });
    }

    const ctaContainer = document.querySelector('.cta-container');
    if (ctaContainer) {
        revealOnScroll(ctaContainer, Array.from(ctaContainer.children), { delay: stagger(0.08) });
    }
}

init();
